<template>
  <page-heading>Add New Player</page-heading>

  <AdminNavigationVue />

  <div class="container">
    <div class="row">
      <div class="col-md-12 left-button mt-lg-2 mb-lg-3">
        <div class="tab tab-left">
          <ul class="list-inline">
            <li class="list-inline-item">
              <router-link
                :to="{
                  name: 'AdminResultEditPanelv2',
                  params: { eventId: eventId },
                }"
                >BACK TO RESULTS
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

   <page-loader v-if="loading" />

    <Form
      class="player-form"
      @submit="submitHandler"
      :validation-schema="schema"
      v-slot="{ errors }"
    >
      <div id="accordionDiv">
        <ul>
          <li>
            <!-- <input type="checkbox"  > -->
            <!-- <i></i> -->
            <h2>REQUIRED FIELDS (*)</h2>

            <div class="row">
              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="type">TYPE</label>
                  <Field
                    id="type"
                    name="type"
                    class="form-control"
                    as="select"
                    @change="selectedType = $event.target.value"
                    :class="{ 'is-invalid': errors.type }"
                    v-model="eventType"
                  >
                    <option
                      :value="item.value"
                      v-for="(item, i) in eventTypeList"
                      :key="i"
                    >
                      {{ item.name }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.type }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6" v-if="eventType === 'day'">
                <div class="form-group">
                  <label for="daySubType">DAY SUB TYPE</label>
                  <Field
                    id="daySubType"
                    name="daySubType"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.daySubType }"
                    v-model="daySubType"
                  >
                    <option
                      :value="item"
                      v-for="(item, i) in ['Normal', 'Gate']"
                      :key="i"
                    >
                      {{ item }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.daySubType }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6" v-if="eventType === 'day'">
                <div class="form-group">
                  <label for="dayId">DAY</label>
                  <Field
                    id="dayId"
                    name="dayId"
                    class="form-control"
                    as="select"
                    @change="selectedDayId = $event.target.value"
                    :class="{ 'is-invalid': errors.dayId }"
                  >
                    <option :value="j.DayId" v-for="j in daysList" :key="j">
                      {{ j.DayName }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.dayId }}</div>
                </div>
              </section>

              <section
                class="col-lg-3 col-md-6"
                v-if="eventType === 'overallgate' ||
                  (selectedDayId && eventType == 'day' && daySubType === 'Gate')
                  "
              >
                <div class="form-group">
                  <label for="gateId">GATE</label>
                  <Field
                    id="gateId"
                    name="gateId"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.gateId }"
                  >
                    <option :value="j.GateId" v-for="j in gatesList()" :key="j">
                      {{ j.GateName }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.gateId }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="lapNo">lapNo</label>
                  <Field
                      name="lapNo"
                      id="lapNo"
                      type="text"
                      class="form-control"
                      value="1"
                      :class="{ 'is-invalid': errors.lapNo }"
                  />
                  <div class="invalid-feedback">{{ errors.lapNo }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="userType">Youth/Master <sup>(0 = Normal, 1 = Youth, 2 = Master)</sup></label>
                  <Field
                      name="userType"
                      id="userType"
                      type="text"
                      class="form-control"
                      value="0"
                      :class="{ 'is-invalid': errors.userType }"
                  />
                  <div class="invalid-feedback">{{ errors.userType }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="categoryId">Category ID</label>
                  <Field
                      id="categoryId"
                      name="categoryId"
                      class="form-control"
                      as="select"
                      :class="{ 'is-invalid': errors.categoryId }"
                      v-model="categoryId"
                  >
                    <option
                        :value="j"
                        v-for="j in [1, 2, 3, 4]"
                        :key="j"
                    >
                      Category {{ j }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.categoryId }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="playerType">PLAYER ADDING AS</label>
                  <Field
                    id="playerType"
                    name="playerType"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.playerType }"
                    v-model="playerType"
                  >
                    <option
                      :value="j"
                      v-for="j in ['Individual', 'Team']"
                      :key="j"
                    >
                      {{ j }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.playerType }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="jerseyId"
                    >JERSEY
                    <img
                      :src="jerseryImage"
                      v-if="jerseryImage"
                      class="jerseyImage"
                  /></label>
                  <Field
                    id="jerseyId"
                    name="jerseyId"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.jerseyId }"
                    @change="jerseryImage = jerseyImageUrl($event.target.value)"
                  >
                    <option :value="j._id" v-for="j in jerseysList" :key="j">
                      {{ j.Name }} - [ID: {{ j._id }}]
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.jerseyId }}</div>
               
                  
                
                </div>
              </section>

      
               <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="userId">USER ID  <sup>(Paste id & Focus out to prefill country)</sup> </label>
              
                  <Field
                   @blur="setUserCountry($event.target.value)"
                    name="userId"
                    id="userId"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.userId }"
                  />
                         <div class="invalid-feedback">{{ errors.userId }}</div>
                </div>
              </section>
    
              <section class="col-lg-3 col-md-6" v-if="playerType == 'Team'">
                <div class="form-group">
                  <label for="teamId">TEAM NAME</label>
                  <Field
                    name="teamId"
                    id="teamId"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.teamId }"
                  >
                    <option :value="j.TeamId" v-for="j in teamsList" :key="j">
                      {{ j.Name }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.teamId }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="userCountryFlag">COUNTRY FLAG</label>

                   

                  <Field
                    id="userCountryFlag"
                    name="userCountryFlag"
                    class="form-control"
                    as="select"
                    v-model="userCountryId"
                    :class="{ 'is-invalid': errors.userCountryFlag }"
                  >
                    <option
                      :value="country.id"
                      v-for="(country, i) in countries"
                      :key="i"
                      
                    >
                      {{ country.name }}
                    </option>
                  </Field>  


                  <div class="invalid-feedback">
                    {{ errors.userCountryFlag }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                   <label for="finishedTime">FINISHED TIME (HH:MM:SS.MS)</label>
                  <Field
                   v-maska="'##:##:##.###'"
                    name="finishedTime"
                    id="finishedTime"
                    type="text"
                    class="form-control"
                   
                    :class="{ 'is-invalid': errors.finishedTime }"
                  />
                  <div class="invalid-feedback">{{ errors.finishedTime }}</div>
                </div>
              </section>
              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                 <label for="gapTime">GAP TIME (HH:MM:SS.MS)</label>
                  <Field
                   v-maska="'##:##:##.###'"
                    name="gapTime"
                    id="gapTime"
                    type="text"
                    class="form-control"
                   
                    :class="{ 'is-invalid': errors.gapTime }"
                  />
                  <div class="invalid-feedback">{{ errors.gapTime }}</div>
                </div>
              </section>
            

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattPerKG">WATT/kg</label>
                  <Field
                    name="wattPerKG"
                    id="wattPerKG"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattPerKG }"
                  />
                  <div class="invalid-feedback">{{ errors.wattPerKG }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="avgPower">AVG WATTS</label>
                  <Field
                    name="avgPower"
                    id="avgPower"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.avgPower }"
                  />
                  <div class="invalid-feedback">{{ errors.avgPower }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="rank">RANK</label>
                  <Field
                    name="rank"
                    id="rank"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.rank }"
                  />
                  <div class="invalid-feedback">{{ errors.rank }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="avgHeartRate">AVG HEART RATE</label>
                  <Field
                    name="avgHeartRate"
                    id="avgHeartRate"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.avgHeartRate }"
                  />
                  <div class="invalid-feedback">{{ errors.avgHeartRate }}</div>
                </div>
              </section>

            
            </div>
          </li>

          <li>
            <input type="checkbox" checked />
            <i></i>
            <h2>OPTIONAL FIELDS</h2>

             
            <div class="row">


           <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="selectionStatus">STATUS</label>
                  <Field
                    value="HYPHEN"
                    id="selectionStatus"
                    name="selectionStatus"
                    class="form-control"
                    as="select"
                    :class="{ 'is-invalid': errors.selectionStatus }"
                  >
                    <option
                      :value="status.name"
                      v-for="(status, i) in selectionStatuses"
                      :key="i"
                    >
                      {{ status.label }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">
                    {{ errors.selectionStatus }}
                  </div>
                </div>
              </section>


               <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="points">POINTS </label>
                  <Field
                    value="0"
                    name="points"
                    id="points"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.points }"
                  />
                  <div class="invalid-feedback">{{ errors.points }}</div>
                </div>
              </section>

             



              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="startedAt">START TIME</label>
                  <Field
                    name="startedAt"
                    id="startedAt"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.startedAt }"
                  />
                  <div class="invalid-feedback">{{ errors.startedAt }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="endedAt">END TIME</label>
                  <Field
                    name="endedAt"
                    id="endedAt"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.endedAt }"
                  />
                  <div class="invalid-feedback">{{ errors.endedAt }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="userWeight">RIDER WEIGHT</label>
                  <Field
                    name="userWeight"
                    value="0"
                    id="userWeight"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.userWeight }"
                  />
                  <div class="invalid-feedback">{{ errors.userWeight }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="rpm">RPM</label>
                  <Field
                    name="rpm"
                    value="0"
                    id="rpm"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.rpm }"
                  />
                  <div class="invalid-feedback">{{ errors.rpm }}</div>
                </div>
              </section>
            

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts5sec"> WATT 5 SEC </label>
                  <Field
                    name="watts5sec"
                    id="watts5sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts5sec }"
                  />
                  <div class="invalid-feedback">{{ errors.watts5sec }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts15sec"> WATT 15 SEC </label>
                  <Field
                    name="watts15sec"
                    id="watts15sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts15sec }"
                  />
                  <div class="invalid-feedback">{{ errors.watts15sec }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts20sec"> WATT 20 SEC </label>
                  <Field
                    name="watts20sec"
                    id="watts20sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts20sec }"
                  />
                  <div class="invalid-feedback">{{ errors.watts20sec }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts30sec"> WATT 30 SEC </label>
                  <Field
                    name="watts30sec"
                    id="watts30sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts30sec }"
                  />
                  <div class="invalid-feedback">{{ errors.watts30sec }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts1min">WATT 1 MIN </label>
                  <Field
                    name="watts1min"
                    id="watts1min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts1min }"
                  />
                  <div class="invalid-feedback">{{ errors.watts1min }}</div>
                </div>
              </section>
              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts3min"> WATT 3 MIN </label>
                  <Field
                    name="watts3min"
                    id="watts3min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts3min }"
                  />
                  <div class="invalid-feedback">{{ errors.watts3min }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts5min">WATT 5 MIN</label>
                  <Field
                    name="watts5min"
                    id="watts5min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts5min }"
                  />
                  <div class="invalid-feedback">{{ errors.watts5min }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts10min">WATT 10 MIN</label>
                  <Field
                    name="watts10min"
                    id="watts10min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts10min }"
                  />
                  <div class="invalid-feedback">{{ errors.watts10min }}</div>
                </div>
              </section>
              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="watts20min">WATT 20 MIN</label>
                  <Field
                    name="watts20min"
                    id="watts20min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.watts20min }"
                  />
                  <div class="invalid-feedback">{{ errors.watts20min }}</div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG5sec">WATT/KG 5 SEC</label>
                  <Field
                    name="wattsPerKG5sec"
                    id="wattsPerKG5sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG5sec }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG5sec }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG20sec">WATT/KG 20 SEC</label>
                  <Field
                    name="wattsPerKG20sec"
                    id="wattsPerKG20sec"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG20sec }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG20sec }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG1min">WATT/KG 1 MIN</label>
                  <Field
                    name="wattsPerKG1min"
                    id="wattsPerKG1min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG1min }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG1min }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG3min">WATT/KG 3 MIN</label>
                  <Field
                    name="wattsPerKG3min"
                    id="wattsPerKG3min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG3min }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG3min }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG5min">WATT/KG 5 MIN</label>
                  <Field
                    name="wattsPerKG5min"
                    id="wattsPerKG5min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG5min }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG5min }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG10min">WATT/KG 10 MIN</label>
                  <Field
                    name="wattsPerKG10min"
                    id="wattsPerKG10min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG10min }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG10min }}
                  </div>
                </div>
              </section>

              <section class="col-lg-3 col-md-6">
                <div class="form-group">
                  <label for="wattsPerKG20min">WATT/KG 20 MIN</label>
                  <Field
                    name="wattsPerKG20min"
                    id="wattsPerKG20min"
                    type="text"
                     value="0"
                    class="form-control"
                    :class="{ 'is-invalid': errors.wattsPerKG20min }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.wattsPerKG20min }}
                  </div>
                </div>
              </section>
            </div>
          </li>
        </ul>

        <div class="row">
          <section class="col-lg-3 col-md-6">
            <label class="hide-mobile">&nbsp;</label>
          </section>

          <section class="col-lg-3 col-md-6">
            <label class="hide-mobile">&nbsp;</label>
          </section>

          <section class="col-lg-3 col-md-6">
            <label class="hide-mobile">&nbsp;</label>
          </section>

          <section class="col-lg-3 col-md-6">
            <label class="hide-mobile">&nbsp;</label>
            <button type="submit" class="btn btn-primary">Submit</button>
          </section>
        </div>
      </div>
    </Form>
  </div>
</template>

<style scoped>
.jerseyImage {
  width: 50px;
  height: 50px;
}


section.accordionDiv {
  padding-top: 2em;
  padding-bottom: 3em;
}

#accordionDiv ul {
  text-align: left;
}

.transition,
p,
ul li i:before,
ul li i:after {
  transition: all 0.3s;
}

#accordionDiv .no-select,
#accordionDiv h2 {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}

#accordionDiv h1 {
  color: #fcb913;
  margin-bottom: 30px;
  margin-top: 0;
}

#accordionDiv h2 {
  color: #fcb913;
  font-family: "hm_light", sans-serif;
  font-size: 20px;
  line-height: 34px;
  text-align: left;
  padding: 15px 15px 0;
  text-transform: none;
  font-weight: 300;
  letter-spacing: 1px;
  display: block;
  margin: 0;
  cursor: pointer;
  transition: 0.2s;
}

#accordionDiv div {
  text-align: left;
  font-family: "hm_light", sans-serif;
  font-size: 14px;
  line-height: 1.45;
  position: relative;
  will-change: max-height;

  opacity: 1;
  transform: translate(0, 0);
  margin-top: 5px;
  margin-bottom: 9px;

  transition: 0.3s opacity, 0.6s max-height;
  hyphens: auto;
  z-index: 2;
  padding-right: 10px;
  padding-left: 10px;
}

#accordionDiv ul {
  list-style: none;
  perspective: 900;
  padding: 0;
  margin: 0;
}

#accordionDiv ul li {
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background: #fff;
  box-shadow: 0 3px 10px -2px rgba(0, 0, 0, 0.1);
  -webkit-tap-highlight-color: transparent;
}

#accordionDiv ul li+li {
  margin-top: 15px;
}

#accordionDiv ul li:last-of-type {
  padding-bottom: 0;
}

#accordionDiv ul li i {
  position: absolute;
  transform: translate(-6px, 0);
  margin-top: 28px;
  right: 15px;
}

#accordionDiv ul li i:before,
ul li i:after {
  content: "";
  position: absolute;
  background-color: #fcb913;
  width: 3px;
  height: 9px;
}

#accordionDiv ul li i:before {
  transform: translate(-2px, 0) rotate(45deg);
}

#accordionDiv ul li i:after {
  transform: translate(2px, 0) rotate(-45deg);
}

#accordionDiv ul li input[type="checkbox"] {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  touch-action: manipulation;
}

#accordionDiv ul li input[type="checkbox"]:checked~h2 {
  color: #000;
}

#accordionDiv ul li input[type="checkbox"]:checked~div {

  max-height: 0;
  transition: 0.3s;
  opacity: 0;

}

#accordionDiv ul li input[type="checkbox"]:checked~i:before {
  transform: translate(2px, 0) rotate(45deg);
}

#accordionDiv ul li input[type="checkbox"]:checked~i:after {
  transform: translate(-2px, 0) rotate(-45deg);
}

ul {
  padding: 0;
  list-style: none;
}

sup {
  font-size: 70%;
}
</style>

<script>
import countries from "@/shared/store/json/country.flags.json";
import { Field, Form } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import * as Yup from "yup";
import AdminNavigationVue from "../../../../shared/components/AdminNavigation.vue";
import {
  eventTypes, selectionStatuses
} from "../../../../shared/events/columns.dto.ts";
import { jerseyImageUrl } from "../../../../shared/events/event.helpers.ts";
const sanitizedPayload = require("string-values-to-numbers")




import $ from 'jquery';

export default {
  name: "AddNewPlayer",
  components: {
    Form,
    Field,
    // Multiselect
    // TopSection,
    AdminNavigationVue,
  },

  computed: {
    ...mapGetters("player", ["playerFieldsData"]),

    daysList() {
      return this.playerFieldsData?.ListOfDays || [];
    },
    jerseysList() {
      return this.playerFieldsData?.ListOfJerseys || [];
    },
    usersList() {
      return this.playerFieldsData?.ListOfUsers || [];
    },
    teamsList() {
      return this.playerFieldsData?.ListOfTeams || [];
    },
  },
  data() {
    return {
      selectedDayId: null,
      loading: false,
      selectedType: null,
      fieldsData: {},
      countries: countries,
      jerseyImageUrl: jerseyImageUrl,
      selectionStatuses: selectionStatuses,
      jerseryImage: null,
      eventId: this.$route.query.eventId,
      eventType: "",
      eventTypeList: eventTypes,
      userCountryId: "",

    };
  },
  setup() {
    const schema = Yup.object().shape({

      jerseyId: Yup.string().required("JERSEY is required"),
      playerType: Yup.string().required("PLAYER ADDING AS is required"),

      teamId: Yup.string().when("playerType", {
        is: "Team",
        then: Yup.string().required("TEAM NAME is required"),
      }),

      gateId: Yup.string().when(
        ["type", "daySubType"],
        {
          is: (type, daySubType) =>
            (type == "gate" && "overallgate") || daySubType == "Gate",
          then: Yup.string().required("Gate ID is required"),
        },
      ),
      dayId: Yup.string().when("type", {
        is: "day",
        then: Yup.string().required("Day ID is required"),
      }),

      daySubType: Yup.string().when("type", {
        is: "day",
        then: Yup.string().required("Day Sub Type is required"),
      }),

      userId: Yup.string().required("USER ID is required"),
      userCountryFlag: Yup.string().required("FLAG is required"),
      type: Yup.string().required("Event Type is required"),
      lapNo: Yup.string().required("LapNo is required"),
      userType: Yup.string().required("Master/Youth is required"),
      categoryId: Yup.string().required("Category Id is required"),

      finishedTime: Yup.string().required("FINISH TIME is required").matches(/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])*(\.[0-5]?[0-9]+)?$/, "Enter valid format e.g: 12:00:12.987"),
      gapTime: Yup.string().required("GAP TIME is required").matches(/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])*(\.[0-5]?[0-9]+)?$/, "Enter valid format e.g: 12:00:12.987"),

      points: Yup.number().required("POINTS is required").min(0),
      wattPerKG: Yup.number().required("W/kg is required").min(0),
      avgPower: Yup.number().required("AVG WATTS is required").min(0),
      rank: Yup.number().required("POSITION is required").min(0),
      avgHeartRate: Yup.string().required("AVG Heart Rate is required"),
      selectionStatus: Yup.string().required("STATUS is required"),
    });
    return {
      schema,
    };
  },

  async mounted() {
    await this.getAddPlayerFieldsData({ eventId: this.eventId });
  },

  methods: {
    ...mapActions("player", ["getAddPlayerFieldsData", "fetchUsersList", "addPlayer"]),
    gatesList() {
      return (
        (this.selectedDayId && this.selectedType === "day"
          ? this.playerFieldsData?.ListOfDays?.find(
            (e) => e.DayId === this.selectedDayId
          )?.ListOfGates
          : this.playerFieldsData?.ListOfGates) || []
      );
    },
    async submitHandler(formData) {
      const finishedTime = this.convertDurationtoSeconds(formData.finishedTime)
      const gapTime = this.convertDurationtoSeconds(formData.gapTime)
      formData = { ...formData, finishedTime, gapTime }
      formData = sanitizedPayload(formData)
      const response = await this.addPlayer({
        ...formData,
        ...{ eventId: this.eventId },
      })

      // response?.error || response?.statusCode == 500 ? false : this.$router.push({ name: "AdminResultEditPanelv2", params: { eventId: this.eventId } });

      if (response?.error) {
        false;
      } else if (response.statusCode == 500) {
        false
      } else {
        this.$router.push({
          name: "AdminResultEditPanelv2",
          params: { eventId: this.eventId },
        });
      }

    },

    convertDurationtoSeconds(duration) {
      const [hours, minutes, seconds] = duration.split(':');
      return (Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds)) * 1000;
    },

    async setUserCountry(value) {
      $('#accordionDiv').addClass('blurry');
      this.loading = true
      const result = await this.fetchUsersList({ userId: value });
      if (result?.data) {
        this.userCountryId = result.data.country
      }
      setTimeout(function () {
        $('#accordionDiv').removeClass("blurry");
      }, 600);
      this.loading = false;
    },


  },
};
</script>
